import { Action, AppState } from './AppProvider';

// Define the reducer function
export const appStateReducer = (state: AppState, action: Action): AppState => {
    switch (action.type) {
        case 'TOGGLE_CHAT_HISTORY':
            return { ...state, isChatHistoryOpen: !state.isChatHistoryOpen };
        case 'UPDATE_CURRENT_CHAT':
            return { ...state, searchInputValue: '', currentChat: action.payload };
        case 'UPDATE_CHAT_HISTORY_LOADING_STATE':
            return { ...state, chatHistoryLoadingState: action.payload };
        case 'UPDATE_CHAT_HISTORY': {
            if (!state.chatHistory) {
                return state;
            }
            let conversationIndex = state.chatHistory.findIndex(conv => conv.id === action.payload.id);
            if (conversationIndex !== -1) {
                let updatedChatHistory = [...state.chatHistory];
                updatedChatHistory[conversationIndex] = action.payload
                return { ...state, chatHistory: updatedChatHistory }
            } else {
                return { ...state, chatHistory: [...state.chatHistory, action.payload] };
            }
        }
        case 'UPDATE_CHAT_TITLE': {
            if (!state.chatHistory) {
                return { ...state, chatHistory: [] };
            }
            const updatedChats = state.chatHistory.map(chat => {
                if (chat.id === action.payload.id) {
                    if (state.currentChat?.id === action.payload.id) {
                        state.currentChat.title = action.payload.title;
                    }
                    return { ...chat, title: action.payload.title };
                }
                return chat;
            });
            return { ...state, chatHistory: updatedChats };
        }
        case 'DELETE_CHAT_ENTRY': {
            if (!state.chatHistory) {
                return { ...state, chatHistory: [] };
            }
            let filteredChat = state.chatHistory.filter(chat => chat.id !== action.payload);
            state.currentChat = null;
            return { ...state, chatHistory: filteredChat };
        }
        case 'DELETE_CHAT_HISTORY':
            return { ...state, chatHistory: [], filteredChatHistory: [], currentChat: null };
        case 'DELETE_CURRENT_CHAT_MESSAGES':{
            if (!state.currentChat || !state.chatHistory) {
                return state;
            }
            const updatedCurrentChat = {
                ...state.currentChat,
                messages: []
            };
            return {
                ...state,
                currentChat: updatedCurrentChat
            };
        }
        case 'FETCH_CHAT_HISTORY':
            return { ...state, chatHistory: action.payload };
        case 'SET_COSMOSDB_STATUS':
            return { ...state, isDynamoDBAvailable: action.payload };
        case 'SET_USER_LOGIN_STATUS':
            return { ...state, loggedInAsRole: action.payload };
        case 'SET_REFRESH_SEARCH_HISTORY':
            return { ...state, refreshSearchHistoryCounter: action.payload };
        case 'SET_SELECTED_SEARCHRESULT':
            return { ...state, selectedSearchResult: action.payload };
        case 'UPDATE_SEARCH_QUERY':
            return { ...state, searchInputValue: action.payload };
        case 'TOGGLE_DARK_MODE':
                return { ...state, isDarkMode: !state.isDarkMode };
        case 'SCREEN_SIZE':
            return { ...state, screenSize: action.payload || 3 };
        case 'UPDATE_CH_FILTER':
            return { ...state, chFilter: action.payload}
        case 'SET_AGENT_OPTIONS':
            return { ...state, agentOptions: action.payload}
        case 'SET_SELECTED_AGENT':
            return { ...state, selectedAgent: action.payload}
        case 'SET_FAQ_LIST':
            return { ...state, faqList: action.payload}
        default:
            return state;
    }
};